import { render } from "./BreadcrumbsList.vue?vue&type=template&id=0d23771e"
import script from "./BreadcrumbsList.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe-registry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__